import { render, staticRenderFns } from "./TaskMoneyConfigjdxinyu.vue?vue&type=template&id=631c047a&"
import script from "./TaskMoneyConfigjdxinyu.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigjdxinyu.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigjdxinyu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports